import { LogLevel, PublicClientApplication } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: '63407807-018e-4b5f-a8a1-1a5707f86470', // Application (client) ID
    // Use 'common' to allow BOTH work/school AND personal Microsoft accounts
    // Use 'consumers' to allow ONLY personal Microsoft accounts (Gmail, Outlook, Hotmail, etc)
    // Use 'organizations' to allow ONLY work/school accounts (blocks personal accounts)
    // Use specific tenant ID for single-tenant only
    authority: 'https://login.microsoftonline.com/consumers',
    redirectUri: 'https://imaster.it-smm.id',
    navigateToLoginRequestUrl: false, // Set to false to avoid redirect loops
  },
  cache: {
    cacheLocation: 'localStorage', // This ensures session persistence
    storeAuthStateInCookie: false, // Set to true if you need IE11 support
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        
        // Only show error logs when not in development mode
        // const isDevelopment = import.meta.env.VITE_PROD === 'true';
        // if (!isDevelopment && level !== LogLevel.Error) {
        //   return;
        // }
        
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

export const logoutMsal = async () => {
  try {
    const msalInstance = new PublicClientApplication(msalConfig);
    await msalInstance.initialize();
    // Get all cached accounts and clear them
    const accounts = msalInstance.getAllAccounts();
            
    if (accounts.length > 0) {
      // Clear each account from MSAL cache
      for (const account of accounts) {
        await msalInstance.clearCache({
          account: account
        });
      }
    }
  } catch (error) {
    console.error("MSAL logout error:", error);
  }

  localStorage.removeItem('token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user');
  localStorage.removeItem('login_id');
  localStorage.removeItem('email_logout');
  localStorage.removeItem('animationTime');
  localStorage.removeItem('animationPointer');
  
  // Clear MSAL cache from localStorage
  // MSAL stores tokens with keys starting with 'msal.'
  const keysToRemove = [];
  // console.log(localStorage.keys())
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && (key.startsWith('msal.') || key.includes('login.windows.net'))) {
      keysToRemove.push(key);
      // console.log('Removing key:', key);
    }
  }
  keysToRemove.forEach(key => localStorage.removeItem(key));
}

export const loginRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email'],
  prompt: "select_account", // Always show account selection dialog
  // prompt options:
  // - "select_account": Always show account picker (like Google)
  // - "login": Force re-authentication
  // - "consent": Force consent screen
  // - "none": Silent authentication only
};